import { Link } from 'react-router-dom';
import { categories } from '@/mocks/fanhao';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                番
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                番号查询指南
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              最全面、最权威的番号查询与解析平台，涵盖番号定义、分类、查询方法及常见格式说明。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              分类导航
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/article/s1-series-guide"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  S1 番号体系完全解读
                </Link>
              </li>
              <li>
                <Link
                  to="/article/prefix-complete-guide"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  番号前缀完全对照手册
                </Link>
              </li>
              <li>
                <Link
                  to="/article/search-methods-intro"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  番号查询入门指南
                </Link>
              </li>
              <li>
                <Link
                  to="/article/fanhao-basic-structure"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  番号的基本结构详解
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              关于本站
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="/sitemap.xml"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  网站地图
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 番号查询与解析完全指南. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}